export { default as ItemListSection } from './Item/Item';
export { default as Footer } from './Footer/Footer';
export { partnerPageFooterAdapter } from './Footer/adapters';
